import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from "./arumni/ืnevbar";
import SignUpForm from "./arumni/SignUpForm";
import SignUp from "./arumni/SignUp";
import MemberPage from "./arumni/statuspage";
import Checkstatus from "./arumni/Checkstatus";

const App = () => {
  return (
    <Router basename="/RegisterAssoc">
      <div>
        <Navbar />

        <Routes>
          <Route path="/" element={<SignUpForm />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/member" element={<MemberPage />} />
          <Route path="/Check" element={<Checkstatus />} />
          
        </Routes>
      </div>
    </Router>
  );
};

export default App;
